import Text16 from '@sdk/components/ui/typography/Text16';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { StripeAddressElementChangeEvent } from '@stripe/stripe-js';

import BillingEmails from '@web/account/billing/BillingEmails/BillingEmails';
import { BillingFieldLabel } from '@web/account/billing/BillingFieldLabel';
import { BillingAddressForm } from '@web/account/billing/BillingAddressForm/BillingAddressForm';

import { useEditBillingInformation } from './editBillingInformation.hooks';
import {
  BillingDetailsInput,
  EditBillingInfoContainer,
  EditBillingInfoHeader,
} from './EditBillingInformation.styles';

type Props = {
  emails: string[];
  setEmails: (emails: string[]) => void;
  billingDetails: string;
  setBillingDetails: (billingDetails: string) => void;
  onAddressChange: (event: StripeAddressElementChangeEvent) => void;
  withSlingAutocomplete: boolean;
};

export const EditBillingInformation = ({
  emails,
  billingDetails,
  setBillingDetails,
  setEmails,
  onAddressChange,
  // when using AddressElement together with PaymentElement we get autocomplete from stripe
  // otherwise we need to use our own google api key
  // https://stripe.com/docs/elements/address-element?platform=web#autocomplete
  withSlingAutocomplete,
}: Props) => {
  const { comapnyNameInputRef, isSubmitted, billingAddressProps } =
    useEditBillingInformation(withSlingAutocomplete);

  return (
    <EditBillingInfoContainer>
      <EditBillingInfoHeader>
        <Text16 semiBold themeColor={ThemeColorType.primary}>
          {gettext('Billing information')}
        </Text16>
      </EditBillingInfoHeader>

      <div>
        <BillingFieldLabel as="label" htmlFor="billing-details">
          {gettext('Company name')}
        </BillingFieldLabel>
        <BillingDetailsInput
          ref={comapnyNameInputRef}
          id="billing-details"
          placeholder={gettext('Company name')}
          onChange={(e): void => setBillingDetails(e.target.value)}
          value={billingDetails}
        />
      </div>

      <BillingAddressForm onChange={onAddressChange} addressProps={billingAddressProps} />

      <BillingEmails emails={emails} setEmails={setEmails} showValidationErrors={isSubmitted} />
    </EditBillingInfoContainer>
  );
};
